import { BadgePercent, Clock, Headset, PackageCheck, ShieldCheck, Sparkles, Star, Truck } from "lucide-react";

export const FEATURE_ICONS = {
  sparkles: Sparkles,
  shield: ShieldCheck,
  truck: Truck,
  percent: BadgePercent,
  package: PackageCheck,
  clock: Clock,
  star: Star,
  headset: Headset,
};

export const FEATURE_ICON_NAMES = Object.keys(FEATURE_ICONS);

export function FeatureIcon({ name, className }) {
  const Icon = FEATURE_ICONS[name] || Sparkles;
  return <Icon className={className} />;
}
